import { render, staticRenderFns } from "./UsersPage.vue?vue&type=template&id=38b6dae4&scoped=true&"
import script from "./UsersPage.vue?vue&type=script&lang=js&"
export * from "./UsersPage.vue?vue&type=script&lang=js&"
import style0 from "./UsersPage.vue?vue&type=style&index=0&id=38b6dae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b6dae4",
  null
  
)

export default component.exports